import * as Sentry from '@sentry/react';
import { env } from '@/lib/env';

/**
 * Initialise Sentry (self-hosted, per CLAUDE.md). Empty DSN → fully disabled, so the
 * code path is always present and prod just supplies the DSN. Browser tracing captures
 * page loads, navigations, fetch spans, and web-vitals; trace headers propagate to the
 * API origin so a frontend event links to the backend trace. `sendDefaultPii: false`
 * — a government platform never ships PII to the error backend by default.
 */
export function initSentry(): void {
  if (!env.VITE_SENTRY_DSN) return;
  Sentry.init({
    dsn: env.VITE_SENTRY_DSN,
    environment: env.VITE_ENV,
    ...(env.VITE_RELEASE ? { release: env.VITE_RELEASE } : {}),
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: env.VITE_SENTRY_TRACES_SAMPLE_RATE,
    tracePropagationTargets: [env.VITE_API_URL],
    sendDefaultPii: false,
  });
}
